function initializeEnvBarScrollEffect() {
  const envBar = document.getElementById("jsEnvBar");
  let lastScrollTop = 0;
  const scrollThreshold = 1;
  const minScrollHeight = 200; // NOTE: SPのheaderが200px以降に非表示になるため、それに合わせる

  window.addEventListener("scroll", () => {
    const currentScrollTop = window.scrollY;
    const scrollDiff = Math.abs(currentScrollTop - lastScrollTop);

    if (currentScrollTop <= minScrollHeight) {
      envBar.classList.remove("scrolled");
      return;
    }
    if (scrollDiff >= scrollThreshold) {
      if (currentScrollTop > lastScrollTop) {
        envBar.classList.add("scrolled");
      } else {
        envBar.classList.remove("scrolled");
      }
      lastScrollTop = currentScrollTop;
    }
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeEnvBarScrollEffect;